export const COPY: Record<string, string> = {
  // Sanity
  SANITY_PROJECT_ID: 'k9lzgpmr',
  SANITY_DATASET: 'production',
  SANITY_API_VERSION: '2021-08-31',

  // Menu Items
  VISAS: 'Visas',
  SERVICES: 'Services',
  FAQ: 'FAQ',
  HOME: 'Home',
  ABOUT: 'About',
  CONTACT: 'Contact',
  TERMS: 'Terms',
  PRIVACY: 'Privacy',
  COOKIES: 'Cookies',

  // Buttons
  SCHEDULE_A_CALL: 'SCHEDULE A CALL',
  BOOK_A_CALL: 'BOOK A CALL',
  SUBSCRIBE: 'SUBSCRIBE',
  SUBMIT_INQUIRY: 'SUBMIT INQUIRY',
  GET_IN_TOUCH: 'GET IN TOUCH',
  SUBMITTING: 'SUBMITTING...',
  SUBSCRIBING: 'SUBSCRIBING...',

  // Landing Visa Section
  VISAS_HEADER: 'Colombian Visa Types',
  TAB_1: 'Visa Types',
  TAB_2: 'Vistitor Visas',
  TAB_3: 'Migrant Visas',
  TAB_4: 'Resident Visas',

  // Landing Services Section
  SERVICES_HEADER: 'Our Services',

  // Landing CTA Section
  CTA_HEADER: 'Not sure where to start?',
  CTA_SUBHEADER:
    'Our team is ready to help. We can reach to you to discuss your needs within a few minutes.',

  // Landing FAQ Section
  FAQ_HEADER: 'Frequently Asked Questions',

  // Landing Newsletter Section
  NEWSLETTER_HEADER: 'Stay up to date with the latest news!',
  NEWSLETTER_SUBHEADER:
    'Receive updates about upcoming changes in Colombian visas and legal processes.',

  // Contact Hero
  CONTACT_HEADER: 'Contact Us',
  CONTACT_SUBHEADER: "Fill out the form below and we'll respond back shortly.",

  // Legal Docs Hero
  TERMS_HEADER: 'Terms of Use',
  PRIVACY_HEADER: 'Privacy Policy',
  COOKIES_HEADER: 'Cookies Policy',
  DOC_DATE: 'Last Updated: April 21, 2023',

  // Alt tags
  LOGO_ALT: 'Site logo',
  FOUNDER_ALT: 'Founder image',

  // Contact Form Labels
  NAME_LABEL: 'What is your full name?',
  EMAIL_LABEL: 'What is your email address?',
  PHONE_LABEL: 'What is your phone number?',
  PREFERRED_LABEL: 'What is your preferred contact method?',
  INQUIRY_TYPE_LABEL: 'Why are your reaching out?',
  CITIZENSHIP_LABEL: 'What citizenship do you have?',
  CURRENTLY_IN_COLOMBIA_LABEL: 'Are you currently in Colombia?',
  CITY_LABEL: 'Which city are you in currently?',
  MESSAGE_LABEL: 'How can we help you?',

  // Contact + Newsletter Form Placeholders
  EMAIL_PLACEHOLDER: 'Enter email address',
  NAME_PLACEHOLDER: 'Enter full name',
  PHONE_PLACEHOLDER: 'Enter phone number',
  SELECT_A_COUNTRY: 'Select a country...',
  SELECT_AN_OPTION: 'Select an option...',
  SELECT_A_CITY: 'Select a city...',
  SELECT_INQUIRY_TYPE: 'Select inquiry type...',
  SELECT_PREFERRED_METHOD: 'Select preferred method...',
  MESSAGE_PLACEHOLDER:
    'Include any relevant details or informtion so that we can better assist you...',

  // Landing Hero Typed Prefix
  WE_HELP_WITH: 'We help with',

  // Form Select Options
  YES: 'Yes',
  NO: 'No',
  BY_WHATSAPP_CALL: 'By WhatsApp call',
  BY_WHATSAPP_MESSAGE: 'By WhatsApp message',
  BY_EMAIL: 'By email',
  VIA_ZOOM_MEETING: 'Via Zoom meeting',
  VIA_GOOGLE_MEETS_MEETING: 'Via Google Meets meeting',

  // Routing
  HOME_URL: '/',
  TERMS_URL: '/terms',
  PRIVACY_URL: '/privacy',
  COOKIES_URL: '/cookies',
  CONTACT_URL: '/contact',
  ABOUT_URL: '/#about',
  FAQ_URL: '/#faq',
  VISAS_URL: '/#visas',
  SERVICES_URL: '/#services',

  // Loading State
  LOADING: 'Loading...',

  // Landing Section IDs
  FAQ_ID: 'faq',
  ABOUT_ID: 'about',
  SERVICES_ID: 'services',
  VISAS_ID: 'visas',

  // Formik
  REQUIRED: 'Required',
  INVALID_EMAIL: 'Invalid format',
}

export default COPY
